import { render, staticRenderFns } from "./AmcServiceForm.vue?vue&type=template&id=671cc6ca&scoped=true&"
import script from "./AmcServiceForm.vue?vue&type=script&lang=js&"
export * from "./AmcServiceForm.vue?vue&type=script&lang=js&"
import style0 from "./AmcServiceForm.vue?vue&type=style&index=0&id=671cc6ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671cc6ca",
  null
  
)

export default component.exports